<template>
    <div class="scores">
        <p-header :title="headerTitle" left-btn="完成" @onLeftBtn="send"/>
        <div class="note">
            <div class="card">
                <div class="icon">
                    <img v-if="order.driver_note_photos.length === 0" src="@/assets/img/order-done.svg">
                    <div class="photo" v-for="photo in order.driver_note_photos" :key="photo.id" :style="photoStyle(photo)">
                        <img v-gallery="'order-' + order.id" :src="photo.url">
                    </div>
                </div>
                <div class="content">
                    <div class="title">
                        <img src="@/assets/img/tick.svg">
                        任務結束
                    </div>
                    <pre class="msg" v-show="order.driver_note">{{ order.driver_note }}</pre>
                </div>
            </div>
        </div>
        <div class="tip">
            <div class="tip-title">關於本次任務滿意度詢問</div>
            <div class="tip-subtitle">您的評價將會匿名顯示，不會透露您的個人資訊</div>
        </div>
        <div class="location" v-if="order.locations.length" @click="goToOrder" v-show="showGoToOrderInfo">
            <div class="name">{{ order.locations[0].alias || order.locations[0].road || '' }}</div>
            <div class="button">
                查看
                <img src="@/assets/img/next-white.svg">
            </div>
        </div>
        <div class="score" v-if="order.driver">
            <div class="title">
                <div class="avatar" :style="driverAvatarStyle"/>
                <div class="name">
                    <div class="alias">
                        #{{ order.driver.knight_id }} {{ order.driver.name }}
                    </div>
                    <div class="subtitle">
                        {{ driverScore.subtitle }}
                    </div>
                </div>
                <div class="favorite" @click.stop="toggleFavoriteDriver">
                    <img v-show="!isFavoriteDriver" src="@/assets/img//heart.svg">
                    <img v-show="isFavoriteDriver" src="@/assets/img/heart-active.svg">
                </div>
            </div>
            <div class="stars">
                <div class="star" @click="driverScore.value = 1">
                    <img v-show="driverScore.value < 1" src="@/assets/img/star-empty.svg">
                    <img v-show="driverScore.value >= 1" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="driverScore.value = 2">
                    <img v-show="driverScore.value < 2" src="@/assets/img/star-empty.svg">
                    <img v-show="driverScore.value >= 2" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="driverScore.value = 3">
                    <img v-show="driverScore.value < 3" src="@/assets/img/star-empty.svg">
                    <img v-show="driverScore.value >= 3" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="driverScore.value = 4">
                    <img v-show="driverScore.value < 4" src="@/assets/img/star-empty.svg">
                    <img v-show="driverScore.value >= 4" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="driverScore.value = 5">
                    <img v-show="driverScore.value < 5" src="@/assets/img/star-empty.svg">
                    <img v-show="driverScore.value >= 5" src="@/assets/img/star.svg">
                </div>
            </div>
            <div class="content" v-show="driverScore.value">
                <div class="message">
                    <span v-show="driverScore.value>=3" v-for="canned in goodCanned" :class="{green: canned.value}" :key="canned.name" @click="canned.value = !canned.value">{{ canned.name }}</span>
                    <span v-show="driverScore.value<3" v-for="canned in badCanned" :class="{green: canned.value}" :key="canned.name" @click="canned.value = !canned.value">{{ canned.name }}</span>
                </div>
<!--                <textarea rows="4" placeholder="還有什麼想法嗎？" v-model="driverScore.content"></textarea>-->
                <p-textarea v-model="driverScore.content" placeholder="還有什麼想法嗎？"></p-textarea>
            </div>
        </div>
        <div class="score">
            <div class="alias">
                {{ orderScore.alias }}
            </div>
            <div class="subtitle">
                {{ orderScore.subtitle }}
            </div>
            <div class="stars">
                <div class="star" @click="orderScore.value = 1">
                    <img v-show="orderScore.value < 1" src="@/assets/img/star-empty.svg">
                    <img v-show="orderScore.value >= 1" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="orderScore.value = 2">
                    <img v-show="orderScore.value < 2" src="@/assets/img/star-empty.svg">
                    <img v-show="orderScore.value >= 2" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="orderScore.value = 3">
                    <img v-show="orderScore.value < 3" src="@/assets/img/star-empty.svg">
                    <img v-show="orderScore.value >= 3" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="orderScore.value = 4">
                    <img v-show="orderScore.value < 4" src="@/assets/img/star-empty.svg">
                    <img v-show="orderScore.value >= 4" src="@/assets/img/star.svg">
                </div>
                <div class="star" @click="orderScore.value = 5">
                    <img v-show="orderScore.value < 5" src="@/assets/img/star-empty.svg">
                    <img v-show="orderScore.value >= 5" src="@/assets/img/star.svg">
                </div>
            </div>
            <div class="content" v-show="orderScore.value">
                <textarea rows="4" placeholder="對本次訂單還有什麼想法？" v-model="orderScore.content"></textarea>
            </div>
        </div>
        <div v-if="order.status === 'done'">
            <div class="score" v-for="score in shopScore" :key="score.target">
                <div class="alias">
                    {{ score.alias }}
                </div>
                <div class="subtitle">
                    {{ score.subtitle }}
                </div>
                <div class="stars">
                    <div class="star" @click="score.value = 1">
                        <img v-show="score.value < 1" src="@/assets/img/star-empty.svg">
                        <img v-show="score.value >= 1" src="@/assets/img/star.svg">
                    </div>
                    <div class="star" @click="score.value = 2">
                        <img v-show="score.value < 2" src="@/assets/img/star-empty.svg">
                        <img v-show="score.value >= 2" src="@/assets/img/star.svg">
                    </div>
                    <div class="star" @click="score.value = 3">
                        <img v-show="score.value < 3" src="@/assets/img/star-empty.svg">
                        <img v-show="score.value >= 3" src="@/assets/img/star.svg">
                    </div>
                    <div class="star" @click="score.value = 4">
                        <img v-show="score.value < 4" src="@/assets/img/star-empty.svg">
                        <img v-show="score.value >= 4" src="@/assets/img/star.svg">
                    </div>
                    <div class="star" @click="score.value = 5">
                        <img v-show="score.value < 5" src="@/assets/img/star-empty.svg">
                        <img v-show="score.value >= 5" src="@/assets/img/star.svg">
                    </div>
                </div>
                <div class="content" v-show="score.value">
                    <textarea rows="4" placeholder="還有什麼想法嗎？" v-model="score.content"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PHeader from './components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2'
    import {addDriver, deleteDriver} from "../apis";
    import AutoHeighTextarea from "./components/AutoHeighTextarea";

    export default {
        name: 'Score',
        components: {
            'p-header': PHeader,
            'p-textarea': AutoHeighTextarea,
        },
        data() {
            return {
                orderId: null,
                order: {
                    status: null,
                    locations: [],
                    driver_note_photos: [],
                },
                orderScore: {
                    alias: '跑跑腿平台體驗',
                    subtitle: '您對這次整體的評價',
                    target: 'order',
                    value: 0,
                    content: '',
                },
                driverScore: {
                    alias: '騎士',
                    subtitle: '跑跑腿騎士',
                    target: 'driver',
                    value: 0,
                    content: '',
                },
                shopScore: [],
                goodCanned: [
                    {
                        name: '態度親切',
                        value: false,
                    },
                    {
                        name: '效率快速',
                        value: false,
                    },
                    {
                        name: '服務優異',
                        value: false,
                    },
                    {
                        name: '乾淨整潔',
                        value: false,
                    },
                ],
                badCanned: [
                    {
                        name: '態度惡劣',
                        value: false,
                    },
                    {
                        name: '效率很差',
                        value: false,
                    },
                    {
                        name: '服務極差',
                        value: false,
                    },
                    {
                        name: '服裝邋遢',
                        value: false,
                    },
                ],
                more: false,
                previousRoute: null,
            }
        },
        computed: {
            headerTitle() {
                return `評價 #${this.orderId}`;
            },
            driverAvatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.order.driver && this.order.driver.avatar) {
                    url = this.order.driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
            isFavoriteDriver() {
                return this.driverIds.findIndex(id => id == this.order.driver.knight_id) >= 0;
            },
            showGoToOrderInfo() {
                return !(this.previousRoute && this.previousRoute.name === 'order' && this.previousRoute.params.id == this.order.id);
            },
            ...mapGetters(['driverIds']),
        },
        methods: {
            photoStyle(photo) {
                return {
                    'background-image': `url(${photo.url})`
                }
            },
            toggleFavoriteDriver() {
                let ApiRequests = [
                    this.isFavoriteDriver ? deleteDriver(this.order.driver.knight_id) : addDriver(this.order.driver.knight_id),
                ];

                Promise.all(ApiRequests).then(() => {
                    this.getDriverIds();
                });
            },
            initScore() {
                this.initShopScores();
                this.initDriverScore();
                this.initOrderScore();
            },
            initOrderScore() {
                let score = this.order.scores.find(score => score.target === 'order');
                if (score) {
                    this.orderScore.value = score.value;
                    this.orderScore.content = score.content;
                }
            },
            initDriverScore() {
                let score = this.order.scores.find(score => score.target === 'driver');
                if (!score) {
                    return;
                }

                this.driverScore.value = score.value;
                this.driverScore.content = score.content;
                let tags = score.tags;
                if (!tags) {
                    return;
                }

                this.goodCanned = [
                    {
                        name: '態度親切',
                        value: tags.findIndex(tag => tag.content === '態度親切') >= 0,
                    },
                    {
                        name: '效率快速',
                        value: tags.findIndex(tag => tag.content === '效率快速') >= 0,
                    },
                    {
                        name: '服務優異',
                        value: tags.findIndex(tag => tag.content === '服務優異') >= 0,
                    },
                    {
                        name: '乾淨整潔',
                        value: tags.findIndex(tag => tag.content === '乾淨整潔') >= 0,
                    },
                ];

                this.badCanned = [
                    {
                        name: '態度惡劣',
                        value: tags.findIndex(tag => tag.content === '態度惡劣') >= 0,
                    },
                    {
                        name: '效率很差',
                        value: tags.findIndex(tag => tag.content === '效率很差') >= 0,
                    },
                    {
                        name: '服務極差',
                        value: tags.findIndex(tag => tag.content === '服務極差') >= 0,
                    },
                    {
                        name: '服裝邋遢',
                        value: tags.findIndex(tag => tag.content === '服裝邋遢') >= 0,
                    },
                ];
            },
            initShopScores() {
                let shops = this.order.locations.filter(location => location.shop_id);
                shops.forEach(shop => {
                    let score = this.order.scores.find(score => score.target == shop.shop_id);
                    this.shopScore.push({
                        alias: shop.alias || shop.road,
                        subtitle: shop.road || '',
                        target: shop.shop_id,
                        value: score ? score.value : 0,
                        content: score ? score.content : '',
                    });
                });
            },
            send() {
                let driverScore = this.driverScore;

                let tags = [];
                if (driverScore.value > 0 && driverScore.value < 3) {
                    tags = this.badCanned.filter((canned) => canned.value).map(canned => canned.name);
                } else if (driverScore.value >= 3) {
                    tags = this.goodCanned.filter((canned) => canned.value).map(canned => canned.name);
                }

                driverScore.tags = tags;

                let scores = [this.orderScore, driverScore, ...this.shopScore];
                scores = scores.filter(score => score.value || (score.tags && score.tags.length));

                if (scores.length < 1) {
                    Swal.fire({
                        type: 'error',
                        title: '評價分數',
                        text: '請確認是否有填寫評價',
                    });
                    return;
                }

                let payload = {
                    id: this.orderId,
                    data: {
                        scores: scores
                    },
                };

                this.scoreOrder(payload).then(() => {
                    this.display = false;
                    Swal.fire({
                        title: '感謝您的評價',
                        text: '祝您有個美好的一天',
                        type: 'success',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        timer: 2000
                    }).then(() => {
                        this.$router.back();
                    })
                }).catch(err => {
                    this.display = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            goToOrder() {
              if (this.previousRoute.name == 'order' && this.previousRoute.params.id == this.order.id) {
                  return this.$router.back();
              }

              return this.$router.push({
                  name: 'order',
                  params: {
                      id: this.order.id
                  }
              });
            },
            ...mapActions(['getOrder', 'scoreOrder', 'getDriverIds'])
        },
        created() {
            this.orderId = this.$route.params.id;
            this.getOrder(this.orderId).then(res => {
                this.order = res.data;
                this.initScore();
            });
            this.getDriverIds();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.previousRoute = from);
        }
    };
</script>

<style lang="scss" scoped>
    .note {
        .card {
            user-select: none;
            margin: 15px;
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
            display: flex;
            padding: 15px;
            align-items: center;

            .icon {
                display: flex;
                .photo {
                    display: flex;
                    flex: 1;
                    height: 56px;
                    width: 56px;
                    border-radius: 5px;
                    background-color: #D8D8D8;
                    background-position: 50% 50%;
                    background-size: cover;
                    background-repeat: no-repeat;

                    &:not(:last-child) {
                        margin-right: 10px;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        filter: alpha(opacity=0);
                    }
                }
            }

            .content {
                margin-left: 15px;

                .title {
                    color: #339933;
                    font-size: 18px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 25px;
                    display: flex;
                    justify-content: start;
                    align-items: flex-start;

                    img {
                        width: 25px;
                        height: 25px;
                    }
                }

                pre {
                    margin: 5px 0 0 0;
                    color: #4A4A4A;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    white-space: pre-wrap;
                    text-align: initial;
                }
            }
        }
    }

    .tip {
        border-radius: 5px;
        background-color: #339933;
        margin: 10px 15px;
        padding: 10px;
        color: #FFFFFF;
        text-align: left;

        .tip-title {
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 25px;
        }

        .tip-subtitle {
            font-size: 12px;
            letter-spacing: 0;
            line-height: 17px;
        }
    }

    .location {
        border-radius: 5px;
        background-color: #4A4A4A;
        margin: 10px 15px;
        padding: 10px;
        display: flex;
        color: #FFFFFF;
        user-select: none;
        cursor: pointer;

        .name {
            flex: 1;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 17px;
            text-align: left;
        }

        .button {
            width: 60px;
            display: flex;
            font-size: 12px;
            letter-spacing: 0;
            line-height: 17px;
            justify-content: flex-end;

            img {
                width: 20px;
                height: 20px;

            }
        }
    }

    .score {
        margin: 0 15px;
        padding: 10px 15px;
        text-align: left;
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        margin-bottom: 10px;

        .title {
            display: flex;
            align-items: center;

            .avatar {
                height: 40px;
                width: 40px;
                border-radius: 90px;
                background-position: 50% 50%;
                background-size: cover;
                margin-right: 15px;
            }
            
            .name {
                flex: 1;
            }

            .favorite {
                cursor: pointer;
                img {
                    width: 15px;
                    height: 15px;
                }
            }
        }

        .alias {
            color: #000000;
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
        }

        .subtitle {
            color: #787878;
            font-size: 12px;
            line-height: 17px;
            margin-top: 3px;
        }

        .stars {
            margin-top: 15px;
            display: flex;
            user-select: none;

            .star {
                cursor: pointer;
                margin-right: 15px;
                img {
                    width: 28px;
                    height: 28px;
                }
            }
        }

        .content {
            margin-top: 15px;
            textarea {
                width: 100%;
                border: 1px solid #DDDDDD;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 5px;
                min-height: 50px !important;
            }

            .message {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 10px;

                span {
                    cursor: pointer;
                    user-select: none;
                    border: 1px solid #CCCCCC;
                    border-radius: 13px;
                    padding: 2px 10px;
                    color: #9B9B9B;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin: 5px;

                    &.green {
                        background-color: #339933;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }

    .more {
        display: flex;
        justify-content: center;

        .more-btn {
            font-size: 14px;
            line-height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #339933;

            img {
                margin-left: 5px;
                width: 20px;
                height: 20px;
                transform: rotate(90deg);
            }
        }
    }

    .divider {
        height: 1px;
        margin: 15px 15px 0 15px;
        background-color: #F5F5F5;
        position: relative;

        &.shop::after {
            content: '— 店家 —';
            position: absolute;
            background-color: #fff;
            top: -12px;
            width: 100px;
            line-height: 24px;
            left: calc(50% - 35px);
            color: #808080;
        }
    }
</style>
